import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  FilterOutlined,
  SearchOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons';
import AccionaButton from '../../components/AccionaButton';
import AntdInput from '../../components/AntdInput';
import { searchableInput, infoValidation } from './index.module.scss';
import { Flex, Form, Radio } from 'antd';

const AccionaTableHeader = ({
  columns,
  hiddenActionCol,
  hiddenCheckBox,
  onClickCheckBoxHeader,
  selectedRows,
  totalItems,
  selectedPage,
  entity,
  setFilters,
  setPagination,
  docketFilter = null,
  total,
  filters,
  expandable,
  isSelectionDisabled,
  items,
}) => {
  const intl = useIntl();
  const [isValidated, setIsValidated] = useState(true);
  const [filterableForm] = Form.useForm();
  useEffect(() => {
    const allFilterPages = Math.ceil(total / 5);
    setPagination((prev) => ({
      ...prev,
      current: allFilterPages >= selectedPage ? selectedPage : 1,
    }));
  }, [selectedPage, setFilters, total, setPagination]);

  const defaultSort = (iconAsc, iconDesc, column, newFilter) => {
    iconAsc.classList.remove('iconSortAscSelected');
    iconDesc.classList.remove('iconSortDescSelected');
    newFilter['sortable'] = column + '-NONE';
    setFilters((prevState) => ({ ...prevState, ...newFilter }));
  };

  useEffect(() => {
    if (docketFilter) {
      document.getElementById('searchableInput-docket_number').value =
        docketFilter || '';
    }
  }, [docketFilter]);

  const sort = (column, order) => {
    const iconAsc = document.getElementById(`sortAsc-${column}`);
    const iconDesc = document.getElementById(`sortDesc-${column}`);
    let newFilter = {};

    Array.from(document.getElementsByClassName('iconSortAsc')).forEach(
      (element) => {
        if (!element.getAttribute('id').includes(column)) {
          element.classList.remove('iconSortAscSelected');
        }
      },
    );
    Array.from(document.getElementsByClassName('iconSortDesc')).forEach(
      (element) => {
        if (!element.getAttribute('id').includes(column)) {
          element.classList.remove('iconSortDescSelected');
        }
      },
    );

    switch (order) {
      case 'ASC':
        if (!iconAsc.className.includes('iconSortAscSelected')) {
          iconAsc.classList.add('iconSortAscSelected');
          iconDesc.classList.remove('iconSortDescSelected');
          newFilter['sortable'] = column + '-ASC';
          setFilters((prevState) => ({ ...prevState, ...newFilter }));
        } else {
          defaultSort(iconAsc, iconDesc, column, newFilter);
        }
        break;
      case 'DESC':
        if (!iconDesc.className.includes('iconSortDescSelected')) {
          iconDesc.classList.add('iconSortDescSelected');
          iconAsc.classList.remove('iconSortAscSelected');
          newFilter['sortable'] = column + '-DESC';
          setFilters((prevState) => ({ ...prevState, ...newFilter }));
        } else {
          defaultSort(iconAsc, iconDesc, column, newFilter);
        }
        break;
      default:
        defaultSort(iconAsc, iconDesc, column, newFilter);
        break;
    }
  };

  const hiddenModals = (column) => {
    Array.from(document.getElementsByClassName(`modalFilterable`)).forEach(
      (element) => {
        if (!element.getAttribute('id').includes(column))
          element.classList.remove('modalFilterable');
      },
    );
    Array.from(document.getElementsByClassName(`modalSearchable`)).forEach(
      (element) => {
        if (!element.getAttribute('id').includes(column))
          element.classList.remove('modalSearchable');
      },
    );
  };

  const filter = (column) => {
    hiddenModals(column);
    const filterModal = document.getElementById(`filterable-${column}`);
    filterModal.classList.toggle('modalFilterable');
  };

  const handleFilter = (column, data = undefined) => {
    let newFilter = {};
    if (data !== undefined) {
      newFilter[column] = data;
    } else {
      newFilter[column] = '';
      document
        .querySelectorAll(`#filterable-${column} input[type="radio"]`)
        .forEach((element) => (element.checked = false));
    }
    setFilters((prevState) => ({ ...prevState, ...newFilter }));
    const filterModal = document.getElementById(`filterable-${column}`);
    filterModal.classList.toggle('modalFilterable');
  };

  const search = (column) => {
    hiddenModals(column);
    const searchModal = document.getElementById(`searchable-${column}`);
    searchModal.classList.toggle('modalSearchable');
  };

  const hadleSearch = (column) => {
    let newFilter = {};
    const stringToSearch = document.getElementById(
      `searchableInput-${column}`,
    ).value;
    newFilter[column] = columns[column].prefix
      ? `${columns[column].prefix}${stringToSearch}`
      : stringToSearch;
    setFilters((prevState) => ({ ...prevState, ...newFilter }));
    const searchModal = document.getElementById(`searchable-${column}`);
    searchModal.classList.toggle('modalSearchable');
  };

  const handleCustomSearch = (filters, columnName) => {
    setFilters((prevState) => {
      const newFilters = { ...prevState, ...filters };
      Object.keys(newFilters)?.forEach((filter) => {
        if (newFilters[filter] === undefined) {
          delete newFilters[filter];
        }
      });
      return newFilters;
    });
    const searchModal = document.getElementById(`searchable-${columnName}`);
    searchModal.classList.toggle('modalSearchable');
  };

  const validator = (value, integer) => {
    if (integer) {
      setIsValidated(!isNaN(value));
    }
  };

  return (
    <thead id="AccionaTableHeader">
      <tr id="HeaderRow">
        {expandable && <th key="expandableHeader" id="expandableHeader" />}
        {Object.keys(columns).map((x) => {
          if (columns[x].isVisible === false || x === 'collapsableColums')
            return null;
          var headerValue =
            entity === 'preProcessedDocuments' && x === 'supplier'
              ? 'associatedTemplate'
              : x;
          return (
            <th
              key={`${x}Header`}
              id={`${x}Header`}
              style={{ position: 'relative', width: columns[x].width }}
            >
              <Flex
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <FormattedMessage id={`${headerValue}`} />
                <Flex
                  align="center"
                  justify="flex-end"
                  gap={5}
                  style={{
                    position: 'absolute',
                    right: 8,
                    top: 11,
                  }}
                >
                  {columns[x].extra ?? null}
                  {columns[x].filterable ? (
                    <FilterOutlined onClick={() => filter(x)} />
                  ) : null}
                  {columns[x].searchable || columns[x].customSearchDropdown ? (
                    <SearchOutlined onClick={() => search(x)} />
                  ) : null}
                  {columns[x].sortable ? (
                    <Flex vertical>
                      <CaretUpOutlined
                        id={`sortAsc-${x}`}
                        className={`iconSortAsc ${
                          columns[x].ascSort ? 'iconSortAscSelected' : ''
                        }`}
                        onClick={() => sort(x, 'ASC')}
                      />
                      <CaretDownOutlined
                        id={`sortDesc-${x}`}
                        className={`iconSortDesc ${
                          columns[x].descSort ? 'iconSortDescSelected' : ''
                        }`}
                        onClick={() => sort(x, 'DESC')}
                      />
                    </Flex>
                  ) : null}
                </Flex>
              </Flex>
              {columns[x].filterable ? (
                <Flex
                  vertical
                  wrap={false}
                  id={`filterable-${x}`}
                  className="modalFilterableHidden"
                >
                  <Form form={filterableForm}>
                    <Form.Item name={'filterable-' + x}>
                      <Flex
                        vertical
                        style={{ flex: '1 1 80%', overflowY: 'auto' }}
                      >
                        <Radio.Group
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            padding: '10px',
                            gap: '10px',
                          }}
                          onChange={({ target }) =>
                            handleFilter(x, target.value)
                          }
                          options={Object.values(columns[x].filterableData).map(
                            (data) => {
                              return { value: data, label: data };
                            },
                          )}
                        />
                      </Flex>
                    </Form.Item>
                    <AccionaButton
                      onClick={() => {
                        filterableForm.resetFields(['filterable-' + x]);
                        handleFilter(x);
                      }}
                      msg={intl.formatMessage({ id: 'uncheck' })}
                      classIcon="icon fas fa-window-close"
                      style={{
                        margin: '8px auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        width: '85%',
                        flex: 0,
                      }}
                      className="btn btn-red"
                    />
                  </Form>
                </Flex>
              ) : null}
              {columns[x].searchable ? (
                <div id={`searchable-${x}`} className="modalSearchableHidden">
                  <AntdInput
                    id={`searchableInput-${x}`}
                    className={searchableInput}
                    allowClear
                    style={{
                      fontSize: '14px',
                      color: 'rgb(0, 0, 0)',
                      borderRadius: 0,
                      padding: '1px 7px',
                      margin: '10px 10px 3px 10px',
                      width: 'auto',
                      border: `${
                        isValidated ? '#c9c9c9' : 'rgb(255, 0, 0)'
                      } solid 1px`,
                      boxShadow: 'none',
                    }}
                    defaultValue={filters[x]}
                    onChange={(e) =>
                      validator(e.target.value, columns[x].integer)
                    }
                  />
                  {!isValidated && (
                    <p className={infoValidation}>
                      {intl.formatMessage({
                        id: 'table.header.validations.integer',
                      })}
                    </p>
                  )}
                  <AccionaButton
                    disabled={!isValidated}
                    onClick={() => hadleSearch(x)}
                    msg={intl.formatMessage({ id: 'search' })}
                    classIcon="icon fas fa-search"
                    style={{
                      margin: '8px auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                      width: '65%',
                    }}
                    className="btn btn-red"
                  />
                </div>
              ) : null}
              {columns[x].customSearchDropdown ? (
                <div
                  id={`searchable-${x}`}
                  className="modalSearchableHidden"
                  style={{ width: '150px' }}
                >
                  {columns[x].customSearchDropdown({ handleCustomSearch })}
                </div>
              ) : null}
            </th>
          );
        })}
        <th hidden={hiddenActionCol} id="ButtonHeader">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <FormattedMessage id="actions" />
          </div>
        </th>
        <th hidden={hiddenCheckBox} id="CheckboxHeader">
          <input
            id="CheckboxHeader.input"
            type="Checkbox"
            checked={
              selectedRows.length ===
                totalItems -
                  items.filter((row) => isSelectionDisabled(row)).length &&
              totalItems !==
                items.filter((row) => isSelectionDisabled(row)).length
            }
            onChange={({ target }) => {
              onClickCheckBoxHeader(target.checked);
            }}
          />
        </th>
      </tr>
    </thead>
  );
};

AccionaTableHeader.propTypes = {
  columnsName: PropTypes.array,
  hiddenActionCol: PropTypes.bool,
  hiddenCheckBox: PropTypes.bool,
  columns: PropTypes.object.isRequired,
  onClickCheckBoxHeader: PropTypes.func.isRequired,
  selectedRows: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalItems: PropTypes.number.isRequired,
  selectedPage: PropTypes.number.isRequired,
  entity: PropTypes.string.isRequired,
  setFilters: PropTypes.func.isRequired,
  setPagination: PropTypes.func.isRequired,
  isSelectionDisabled: PropTypes.func.isRequired,
  docketFilter: PropTypes.number,
  total: PropTypes.number.isRequired,
  filters: PropTypes.object,
  expandable: PropTypes.shape({
    rowExpandable: PropTypes.func,
    expandedRowRender: PropTypes.func,
  }),
  items: PropTypes.arrayOf(PropTypes.object),
};

AccionaTableHeader.defaultProps = {
  columnsName: [],
  hiddenActionCol: true,
  hiddenCheckBox: true,
  filters: undefined,
  docketFilter: undefined,
  expandable: undefined,
  isSelectionDisabled: () => {},
  items: [],
};

export default AccionaTableHeader;
